import React from "react";

const AdvisorCard = ({
  id,
  name = "Name",
  title = "Ttile",
  onKnowMoreClick,
  onContactClick,
}) => {
  const patternId = `b-${id}`;

  const patternSvg = (() => {
    switch (id) {
      case 1:
        return (
          <>
            <defs>
              <pattern
                id={patternId}
                width="40"
                height="40"
                patternTransform="rotate(50)scale(5)"
                patternUnits="userSpaceOnUse"
              >
                <rect width="100%" height="100%" fill="#87d498" />
                <path
                  fill="none"
                  stroke="#f3e9d3"
                  strokeWidth="5"
                  d="M40 10v20M0 10v20M10 0h20M10 40h20m10 10L30 40l10-10 10 10zM0 50l-10-10L0 30l10 10zm40-40L30 0l10-10L50 0zM0 10-10 0 0-10 10 0z"
                />
                <path
                  fill="none"
                  stroke="#1a936f"
                  strokeWidth="5"
                  d="M20-10v20m0 20v20m-30-30h20m20 0h20M20 30 10 20l10-10 10 10z"
                />
              </pattern>
            </defs>
            <rect
              width="800%"
              height="800%"
              fill={`url(#${patternId})`}
              transform="translate(-355 -310)"
            />
          </>
        );

      case 2:
        return (
          <>
            <defs>
              <pattern
                id={patternId}
                width="50.5"
                height="53.5"
                patternTransform="rotate(160)scale(2)"
                patternUnits="userSpaceOnUse"
              >
                <rect width="100%" height="100%" fill="#0095c7" />
                <path fill="#03045e" d="m25.25 0-20 20h20zm0 20v20l20-20z" />
                <path fill="#00b3d6" d="m25.25 0 20 20V0zm-20 20v20h20z" />
              </pattern>
            </defs>
            <rect
              width="800%"
              height="800%"
              fill={`url(#${patternId})`}
              transform="translate(-174 -174)"
            />
          </>
        );

      case 3:
        return (
          <>
            <defs>
              <pattern
                id={patternId}
                width="46.5"
                height="46.5"
                patternTransform="rotate(35)scale(3)"
                patternUnits="userSpaceOnUse"
              >
                <rect width="100%" height="100%" fill="#033a6d" />
                <path
                  fill="none"
                  stroke="#011f4b"
                  strokeLinecap="square"
                  strokeWidth="4"
                  d="M27.31-2.917a5 5 0 0 1 0 5.834m-8.12 0a5 5 0 0 1 0-5.834m-4.827 7.501a10 10 0 0 1 0-9.169m17.774.001a10 10 0 0 1 0 9.169M10.181 7.36a15 15 0 0 1-.001-14.722m26.14 0a15 15 0 0 1 0 14.724m-9.01 36.22a5 5 0 0 1 0 5.835m-8.12 0a5 5 0 0 1 0-5.834m-4.827 7.501a10 10 0 0 1 0-9.169m17.774.001a10 10 0 0 1 0 9.169M10.181 53.86a15 15 0 0 1-.001-14.723m26.14 0a15 15 0 0 1 0 14.724m6.12-27.693a5 5 0 0 1 0-5.834m-4.827 7.5a10 10 0 0 1 0-9.169M33.431 30.61a15 15 0 0 1-.001-14.722M4.06 20.332a5 5 0 0 1 0 5.835m4.827-7.501a10 10 0 0 1 0 9.169m4.183-11.947a15 15 0 0 1 0 14.724"
                />
                <path
                  fill="none"
                  stroke="#6397b0"
                  strokeLinecap="square"
                  strokeWidth="4"
                  d="M43.582 42.44a5 5 0 0 1 5.835 0m-7.501-4.827a10 10 0 0 1 9.169 0M39.138 33.43a15 15 0 0 1 14.724 0m-56.781 9.01a5 5 0 0 1 5.836 0m-7.501-4.827a10 10 0 0 1 9.169 0M-7.362 33.43a15 15 0 0 1 14.724 0M49.417 4.06a5 5 0 0 1-5.834 0m7.501 4.827a10 10 0 0 1-9.169 0m11.946 4.182a15 15 0 0 1-14.723.001M2.917 4.06a5 5 0 0 1-5.834 0m7.501 4.827a10 10 0 0 1-9.169 0M7.36 13.069a15 15 0 0 1-14.722.001m27.694 6.12a5 5 0 0 1 5.835 0m0 8.12a5 5 0 0 1-5.834 0m7.5 4.827a10 10 0 0 1-9.168 0m.001-17.774a10 10 0 0 1 9.169 0m2.776 21.956a15 15 0 0 1-14.723.001m0-26.14a15 15 0 0 1 14.724 0"
                />
              </pattern>
            </defs>
            <rect
              width="800%"
              height="800%"
              fill={`url(#${patternId})`}
              transform="translate(-210 -252)"
            />
          </>
        );

      case 4:
        return (
          <>
            <defs>
              <pattern
                id={patternId}
                width="80"
                height="80"
                patternTransform="rotate(160)scale(2)"
                patternUnits="userSpaceOnUse"
              >
                <rect width="100%" height="100%" fill="#fcc14a" />
                <path
                  fill="#eae3b8"
                  d="m0 0 20 20L40 0H30L20 10 10 0zm0 10v10h10zm40 0L30 20h10zm0 10v10l10-10zm20 0L40 40l20 20 20-20zm10 0 10 10V20zM60 30l10 10-10 10-10-10zM40 50v10h10zm0 10H30l10 10zm40-10L70 60h10zM0 60v10l10-10zm20 0L0 80h10l10-10 10 10h10z"
                />
                <path
                  fill="#002e47"
                  d="M40 0v10l10 10h10zm20 20h10l10-10V0zM50 0l10 10L70 0zM10 20 0 30v10l20-20zm10 0 20 20V30L30 20zm20 20L20 60h10l10-10zM20 60 0 40v10l10 10zm0-30L10 40l10 10 10-10zm30 30L40 70v10l20-20zm10 0 20 20V70L70 60zm0 10L50 80h20z"
                />
              </pattern>
            </defs>
            <rect
              width="800%"
              height="800%"
              fill={`url(#${patternId})`}
              transform="translate(-288 -528)"
            />
          </>
        );

      default:
        return (
          <>
            <defs>
              <pattern
                id="a"
                width="40"
                height="69.282"
                patternTransform="rotate(150)scale(2)"
                patternUnits="userSpaceOnUse"
              >
                <rect width="100%" height="100%" fill="#c97d5e" />
                <path
                  fill="none"
                  stroke="#79392f"
                  strokeWidth="4"
                  d="M13.333-3.849v23.094M6.667-15.396l20 11.547M13.333-19.245l20 11.547M20 0v23.094m20-34.641-6.667 3.849-6.666 3.849L20 0M0-11.547l6.667 3.849 6.666 3.849L20 0m0-23.094 20 11.547v23.094L20 23.094l-6.667-3.849-6.666-3.849L0 11.547v-23.094l6.667-3.849 6.666-3.849zM40-3.769 20 7.698m20-3.849-16.253 9.384L20 15.396M6.667-7.698v23.094m6.666 50.037v23.094M6.667 53.886l20 11.547M13.333 50.037l20 11.547M20 69.282v23.094m20-34.641-6.667 3.849-6.666 3.849L20 69.282M0 57.735l6.667 3.849 6.666 3.849L20 69.282m0-23.094 20 11.547v23.094L20 92.376l-6.667-3.849-6.666-3.849L0 80.829V57.735l6.667-3.849 6.666-3.849zm20 19.325L20 76.98m20-3.849L20 84.678M6.667 61.584v23.094m26.666-53.886v23.094m-6.666-34.641 20 11.547M33.333 15.396l20 11.547M40 34.641v23.094m20-34.641-6.667 3.849-6.666 3.849L40 34.641M20 23.094l6.667 3.849 6.666 3.849L40 34.641m0-23.094 20 11.547v23.094L40 57.735l-6.667-3.849-6.666-3.849L20 46.188V23.094l6.667-3.849 6.666-3.849zm20 19.325L40 42.339m20-3.849L40 50.037M26.667 26.943v23.094M-6.667 30.792v23.094m-6.666-34.641 20 11.547M-6.667 15.396l20 11.547M0 34.641v23.094m20-34.641-6.667 3.849-6.666 3.849L0 34.641m-20-11.547 6.667 3.849 6.666 3.849L0 34.641m0-23.094 20 11.547v23.094L0 57.735l-6.667-3.849-6.666-3.849L-20 46.188V23.094l6.667-3.849 6.666-3.849zm20 19.325L0 42.339m20-3.849L0 50.037m-13.333-23.094v23.094"
                />
              </pattern>
            </defs>
            <rect
              width="800%"
              height="800%"
              fill="url(#a)"
              transform="translate(-78 -28)"
            />
          </>
        );
    }
  })();

  return (
    <div className="advisor-card">
      <div className="advisor-card__img">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="100%"
          height="100%"
          preserveAspectRatio="none"
        >
          <rect fill="#ffffff" width={540} height={450} />
          {patternSvg}
        </svg>
      </div>

      <div className="advisor-card__avatar">
        <img className="advisor-card__avatar-img" src="/assets/avatars/male.svg" alt={`${name}'s avatar`} />
        {/* <svg viewBox="0 0 128 128" xmlns="http://www.w3.org/2000/svg">
          <circle cx={64} cy={64} fill="#ff8475" r={60} />
          <circle cx={64} cy={64} fill="#f85565" opacity=".4" r={48} />
          <path
            d="m64 14a32 32 0 0 1 32 32v41a6 6 0 0 1 -6 6h-52a6 6 0 0 1 -6-6v-41a32 32 0 0 1 32-32z"
            fill="#7f3838"
          />
          <path
            d="m62.73 22h2.54a23.73 23.73 0 0 1 23.73 23.73v42.82a4.45 4.45 0 0 1 -4.45 4.45h-41.1a4.45 4.45 0 0 1 -4.45-4.45v-42.82a23.73 23.73 0 0 1 23.73-23.73z"
            fill="#393c54"
            opacity=".4"
          />
          <circle cx={89} cy={65} fill="#fbc0aa" r={7} />
          <path
            d="m64 124a59.67 59.67 0 0 0 34.69-11.06l-3.32-9.3a10 10 0 0 0 -9.37-6.64h-43.95a10 10 0 0 0 -9.42 6.64l-3.32 9.3a59.67 59.67 0 0 0 34.69 11.06z"
            fill="#4bc190"
          />
          <path
            d="m45 110 5.55 2.92-2.55 8.92a60.14 60.14 0 0 0 9 1.74v-27.08l-12.38 10.25a2 2 0 0 0 .38 3.25z"
            fill="#356cb6"
            opacity=".3"
          />
          <path
            d="m71 96.5v27.09a60.14 60.14 0 0 0 9-1.74l-2.54-8.93 5.54-2.92a2 2 0 0 0 .41-3.25z"
            fill="#356cb6"
            opacity=".3"
          />
          <path d="m57 123.68a58.54 58.54 0 0 0 14 0v-25.68h-14z" fill="#fff" />
          <path
            d="m64 88.75v9.75"
            fill="none"
            stroke="#fbc0aa"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={14}
          />
          <circle cx={39} cy={65} fill="#fbc0aa" r={7} />
          <path
            d="m64 91a25 25 0 0 1 -25-25v-16.48a25 25 0 1 1 50 0v16.48a25 25 0 0 1 -25 25z"
            fill="#ffd8c9"
          />
          <path
            d="m91.49 51.12v-4.72c0-14.95-11.71-27.61-26.66-28a27.51 27.51 0 0 0 -28.32 27.42v5.33a2 2 0 0 0 2 2h6.81a8 8 0 0 0 6.5-3.33l4.94-6.88a18.45 18.45 0 0 1 1.37 1.63 22.84 22.84 0 0 0 17.87 8.58h13.45a2 2 0 0 0 2.04-2.03z"
            fill="#bc5b57"
          />
          <path
            d="m62.76 36.94c4.24 8.74 10.71 10.21 16.09 10.21h5"
            style={{
              fill: "none",
              strokeLinecap: "round",
              stroke: "#fff",
              strokeMiterlimit: 10,
              strokeWidth: 2,
              opacity: ".1",
            }}
          />
          <path
            d="m71 35c2.52 5.22 6.39 6.09 9.6 6.09h3"
            style={{
              fill: "none",
              strokeLinecap: "round",
              stroke: "#fff",
              strokeMiterlimit: 10,
              strokeWidth: 2,
              opacity: ".1",
            }}
          />
          <circle cx={76} cy="62.28" fill="#515570" r={3} />
          <circle cx={52} cy="62.28" fill="#515570" r={3} />
          <ellipse
            cx="50.42"
            cy="69.67"
            fill="#f85565"
            opacity=".1"
            rx="4.58"
            ry="2.98"
          />
          <ellipse
            cx="77.58"
            cy="69.67"
            fill="#f85565"
            opacity=".1"
            rx="4.58"
            ry="2.98"
          />
          <g fill="none" strokeLinecap="round" strokeLinejoin="round">
            <path d="m64 67v4" stroke="#fbc0aa" strokeWidth={4} />
            <path
              d="m55 56h-9.25"
              opacity=".2"
              stroke="#515570"
              strokeWidth={2}
            />
            <path
              d="m82 56h-9.25"
              opacity=".2"
              stroke="#515570"
              strokeWidth={2}
            />
          </g>
          <path
            d="m64 84c5 0 7-3 7-3h-14s2 3 7 3z"
            fill="#f85565"
            opacity=".4"
          />
          <path
            d="m65.07 78.93-.55.55a.73.73 0 0 1 -1 0l-.55-.55c-1.14-1.14-2.93-.93-4.27.47l-1.7 1.6h14l-1.66-1.6c-1.34-1.4-3.13-1.61-4.27-.47z"
            fill="#f85565"
          />
          <svg viewBox="0 0 128 128" xmlns="http://www.w3.org/2000/svg" />
        </svg> */}
      </div>
      <div className="advisor-card__title">{name}</div>
      <div className="advisor-card__subtitle">{title}</div>
      <div className="advisor-card__wrapper">
        <button className="advisor-card__btn" onClick={onKnowMoreClick}>
          Know more
        </button>
        <button
          className="advisor-card__btn advisor-card__btn-solid"
          onClick={onContactClick}
        >
          Contact
        </button>
      </div>
    </div>
  );
};

export default AdvisorCard;
